











































































































































import { Component, Inject, Mixins } from "vue-property-decorator";
import Context from "@/mixins/context";
import {
  IInvoiceProvider,
  IInvoiceProviderMethods
} from "@/models/providers/invoice";

@Component
export default class PaymentsTable extends Mixins(Context) {
  // Inject

  @Inject({ from: "invoiceProvider" })
  public readonly $invoiceProvider!: () => IInvoiceProvider;

  @Inject({ from: "invoiceProviderMethods" })
  public readonly $invoiceMethods!: IInvoiceProviderMethods;

  public get $invoice() {
    return this.$invoiceProvider();
  }

  public get payments() {
    return this.$_.orderBy(
      this.$invoice.invoice && this.$invoice.invoice.payments,
      ["first_date_time_captured"],
      ["desc"]
    );
  }

  public get showCta() {
    return !this.$invoice.isCreditNote && this.$invoice.isPayable;
  }

  public get contentAvailable() {
    return this.$userCan("list_invoice_payments");
  }
}
